<template>
    <svg 
    xmlns="http://www.w3.org/2000/svg"
    width="16" 
    height="16" 
    :fill="fillColor" 
    :class="svgClass" 
    viewBox="0 0 24 24"
    >
      <path stroke="black" stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m6.75 12H9m1.5-12H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
</svg>

</template>

<script setup>
import { defineProps, computed } from 'vue';

const props = defineProps(['iconClass', 'fill'])

const svgClass = computed(()=>{
    return props.iconClass ? props.iconClass : 'h-3 w-3'
})

const fillColor = computed(() => {
    return props.fill ? props.fill : 'black'
})

</script>